import getTrophyInfo from "../../../objects/CommonUse/get_trophy_info";
import determineCelebrationText from "../../../objects/CommonUse/determine_celebration_text";
import BadgesInfoDataset from "../badgesDatasets/badges_info_dataset";
import { doubleToStringMonthly } from "../../../objects/CommonUse/double_functions";

export const addCelebrationToNotificationArr = (itemID, inputType, title, badgeObj) => {
    let medalType = "";
    if (!badgeObj){
        badgeObj = {};
    }
    let imgSrc = "";
    let additionalText = "";
    let awardType = "";
    if (inputType === "achievement"){
        const awardCode = itemID.substring(0,1);
        const medalTypeObj = getTrophyInfo(awardCode);
        medalType = medalTypeObj.medalType;
        additionalText = determineCelebrationText(medalType, itemID);
        awardType = "trophy";
        if (medalTypeObj.medalType === "Jewel"){
            awardType = "jewel";
        }
        imgSrc = medalTypeObj.imgSrc;
    }else{
        title = badgeObj.badgeName;  
        const moodPoints = (+badgeObj.moodPointsEarned).toFixed(0);
        additionalText = "Your " + badgeObj.awardType + " was increased by " + 
            doubleToStringMonthly(badgeObj.awardAmount) +
            " and your mood points were increased by " + moodPoints + " points";
        const badgeInfoObj = BadgesInfoDataset.find(elem => elem.badgeCode === badgeObj.badgeCode);
        imgSrc = "./assets/Awards/" + badgeInfoObj.pictureName;
        awardType = badgeInfoObj.badgeName;
        itemID = "";
    }
    const notificationObj = {variety: "celebration", 
        awardType: awardType,
        awardID: itemID,
        awardTitle: title,
        awardCode: itemID,
        additionalText: additionalText,
        imgSrc: imgSrc,
    };
    return notificationObj;
}
export default addCelebrationToNotificationArr;
